import Head from "next/head";
import Script from "next/script";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { appWithTranslation } from "next-i18next";

import * as gtag from "../helpers/gtag";
import Layout from "../components/Layout";
import "../styles/global.css";

// ✅ Import protection logic
import { protectAdSense } from "../lib/adsense-protection";

const MyApp = ({ Component, pageProps }) => {
  const router = useRouter();

  // ✅ Send pageview to Google Analytics on route change
  useEffect(() => {
    const handleRouteChange = (url) => gtag.pageview(url);
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => router.events.off("routeChangeComplete", handleRouteChange);
  }, [router.events]);

  // ✅ Start AdSense protection after ads are rendered
  useEffect(() => {
    setTimeout(() => {
      protectAdSense();
    }, 3000);
  }, []);

 // ✅ Google reCAPTCHA v3 logic
  useEffect(() => {
    if (typeof window === "undefined" || !window.grecaptcha) return;

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute("6LeZaoYrAAAAALrvOJP2xxILjE-NR6oL5AP1JMAT", { action: "homepage_visit" })
        .then((token) => {
          fetch("/api/verify-recaptcha", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.success && data.score >= 0.5) {
                console.log("✅ reCAPTCHA verified: Human");
              } else {
                console.warn("🚫 Bot detected – hiding ads");
                const ads = document.querySelectorAll(".adsbygoogle");
                ads.forEach((ad) => (ad.style.display = "none"));
              }
            });
        });
    });
  }, []);

  // ✅ Support per-page custom layout or fallback to default Layout
  const getLayout = Component.getLayout || ((page) => <Layout>{page}</Layout>);

  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="author" content="Netbeans Systems" />
        <meta name="theme-color" content="#2d3748" />
        <meta name="robots" content="index, follow" />
        <link rel="icon" href="/img/files.png" />
        <link rel="apple-touch-icon" href="/img/files.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <meta
          name="google-site-verification"
          content="add-your-google-site-verification-code"
        />
      </Head>

<Script
  strategy="afterInteractive"
  src={`https://www.google.com/recaptcha/api.js?render=6LeZaoYrAAAAALrvOJP2xxILjE-NR6oL5AP1JMAT`} // replace
/>
      {/* ✅ Google AdSense */}
      <Script
        async
        strategy="afterInteractive"
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8411374251978045"
        crossOrigin="anonymous"
      />

      {/* ✅ Google Analytics */}
      <Script
        strategy="lazyOnload"
        src={`https://www.googletagmanager.com/gtag/js?id=${gtag.GA_TRACKING_ID}`}
      />
      <Script
        id="gtag-init"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gtag.GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />

      {getLayout(<Component {...pageProps} />)}
    </>
  );
};

export default appWithTranslation(MyApp);
